/**
 * LINKURIOUS CONFIDENTIAL
 * Copyright Linkurious SAS 2012 - 2016
 *
 * Created by maximeallex on 2016-11-30.
 */

'use strict';
import {Directive, HostListener, Input, ElementRef, OnDestroy, OnChanges, ChangeDetectorRef} from '@angular/core';
import { TooltipService } from './service';
import { SafeHtml } from "@angular/platform-browser";
import { Tools } from "linkurious-shared";

@Directive({
  selector: '[tooltip]'
})
export class TooltipDirective implements OnDestroy, OnChanges {
  @Input() tooltip: string|SafeHtml;
  @Input() disabled: boolean = false;
  @Input() truncation: number = undefined;
  @Input() copy: boolean = false;
  @Input() position: 'top'|'bottom'|'left'|'right' = 'top';
  @Input() maxWidth: number = 250;
  private _isOpened: boolean = false;
  private _timeOut: any;

  constructor(
    private _tooltipService: TooltipService,
    private _el: ElementRef,
    private _detectorRef: ChangeDetectorRef) {}

  ngOnChanges(e): void {
    if ( Tools.isDefined(e.tooltip) &&
      this._isOpened &&
      !(Tools.isDefined(e.disabled) && e.disabled.currentValue === true)
    ) {
      this._tooltipService.update(e.tooltip.currentValue);
    }
    if ( Tools.isDefined(e.disabled) && e.disabled.currentValue === true ) {
      this.close();
    }
    this._detectorRef.markForCheck();
  }

  /**
   * Open the tooltip on mouse over
   */
  @HostListener('mouseover', ['$event'])
  onHover(e: MouseEvent) {
    if ( !this.disabled ) {
      e.preventDefault();
      this._timeOut = setTimeout(() => {
        if ( !this._isOpened &&
              ( this._el.nativeElement.getBoundingClientRect().x !== 0
                || this._el.nativeElement.getBoundingClientRect().y !== 0
              )
        ) {
          this._tooltipService.open({
            content: this.tooltip,
            position: this.position,
            placement: this._el.nativeElement.getBoundingClientRect(),
            truncation: this.truncation,
            copy: this.copy,
            maxWidth: this.maxWidth
          });
          this._isOpened = true;
        }
      }, 100);
    }
  }

  /**
   * Close the tooltip when leaving mouse leaving the trigger element or the tooltip
   */
  @HostListener('document:mousemove', ['$event'])
  onLeave(e: MouseEvent) {
    if (
      !document.getElementsByTagName('lk-tooltip')[0].contains(e.target as Node) &&
      !this._el.nativeElement.contains(e.target as Node)
    ) {
      clearTimeout(this._timeOut);
      this.close();
    }
  }

  ngOnDestroy() {
    this._tooltipService.close();
  }

  private close() {
    if ( this._isOpened ) {
      this._tooltipService.close();
      this._isOpened = false;
    }
  }
}
